<template>
    <v-app pb-3 class="transit">
        <v-content>
            <v-container class="container">
                <v-layout class="transit__header">
                    <v-flex xs12 py-2>
                        <a href="/list" class="header-link">Страховые продукты</a>
                        <h1>ОСАГО не РФ</h1>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-form ref="form" v-model="valid">
                <v-container class="container transit__drivers py-0">
                    <v-layout class="transit__drivers__header">
                        <v-flex xs12 pb-2>
                            <h2>Водители</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 py-0>
                            <v-checkbox
                                v-model="unlimitedDrivers"
                                label="Количество допущеных водителей не ограничено"
                                @change="unlimitedDriversChange(unlimitedDrivers)"
                                class="mt-0"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    class="container transit__drivers-list py-0"
                    v-for="driver in drivers"
                    :key="driver.n"
                    v-if="!unlimitedDrivers"
                >
                    <v-layout class="transit__drivers__header">
                        <v-flex xs12 pt-4 pb-0>
                            <h3 v-if="driver.isOwner && driver.isInsurer">
                                Водитель {{ driver.n }} (Собственник и страхователь)
                            </h3>
                            <h3 v-if="!driver.isOwner && driver.isInsurer">
                                Водитель {{ driver.n }} (Страхователь)
                            </h3>
                            <h3 v-if="driver.isOwner && !driver.isInsurer">
                                Водитель {{ driver.n }} (Собственник)
                            </h3>
                            <h3 v-if="!driver.isOwner && !driver.isInsurer">
                                Водитель {{ driver.n }}
                            </h3>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 sm4 py-0>
                            <v-checkbox
                                label="Водитель является собственником авто"
                                v-model="driver.isOwner"
                                @change="driverIsOwnerChange(driver)"
                                class="pb-0"
                            />
                        </v-flex>
                        <v-flex xs12 sm4 py-0>
                            <v-checkbox
                                label="Водитель является страхователем авто"
                                v-model="driver.isInsurer"
                                @change="driverIsInsurerChange(driver)"
                                class="pb-0"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0 style="align-self: flex-end">
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="driver.fio.old"
                                :label="'Менялась фамилия после ' + yearBefore"
                                @change="oldSurnameToggle(driver)"
                            />
                            <osago-name
                                v-model="driver.fio.surname"
                                label="Фамилия"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0 v-if="driver.fio.old">
                            <osago-name
                                v-model="driver.fio.oldSurname"
                                label="Старая фамилия"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="driver.fio.name"
                                label="Имя"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="driver.fio.noPatronymic"
                                label="Без отчества"
                            />
                            <osago-name
                                v-model="driver.fio.patronymic"
                                label="Отчество"
                                :isDisabled="driver.fio.noPatronymic"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="driver.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="driver.dateDriverPassport = getDateDriverPassport(driver);
                                    driver.dateFirstLicense = getDateFirstLicense(driver)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 sm6 md4 lg4 py-0 style="align-self: flex-end">
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="driver.license.old"
                                :label="'Менял ВУ после ' + yearBefore"
                                @change="oldLicenseToggle(driver)"
                            />
                            <v-layout row wrap>
                                <v-flex xs12 sm6 py-0 style="align-self: flex-end" class="padding-right">
                                    <v-text-field
                                        v-model="driver.license.series"
                                        label="Серия ВУ"
                                        :rules="[rules.base, rules.licenseSeriesLength]"
                                        @keyup.native="driver.license.series = removeSymbols(driver.license.series)"
                                    />
                                </v-flex>
                                <v-flex xs12 sm6 py-0 style="align-self: flex-end" class="padding-left">
                                    <v-text-field
                                        v-model="driver.license.number"
                                        label="Номер ВУ"
                                        :rules="[rules.required, rules.base, rules.licenseNumberLength]"
                                        @keyup.native="driver.license.number = removeSymbols(driver.license.number)"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg4 py-0 style="align-self: flex-end" v-if="driver.license.old">
                            <h4 style="display: inline">Старое ВУ</h4>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 py-0 style="align-self: flex-end" class="padding-right">
                                    <v-text-field
                                        v-model="driver.license.oldSeries"
                                        label="Серия ВУ"
                                        :rules="[rules.base, rules.licenseSeriesLength]"
                                        @keyup.native="driver.license.oldSeries = removeSymbols(driver.license.oldSeries)"
                                    />
                                </v-flex>
                                <v-flex xs12 sm6 py-0 style="align-self: flex-end" class="padding-left">
                                    <v-text-field
                                        v-model="driver.license.oldNumber"
                                        label="Номер ВУ"
                                        :rules="[rules.required, rules.base, rules.licenseNumberLength]"
                                        @keyup.native="driver.license.oldNumber = removeSymbols(driver.license.oldNumber)"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs10 sm5 md3 py-0 style="align-self: flex-end">
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="driver.license.rememberYearOnly"
                                label="Помню только год"
                            />
                            <v-autocomplete
                                v-if="driver.license.rememberYearOnly"
                                :items="getFirstLicenseYears(driver.dateFirstLicense, dateToday)"
                                :rules="[rules.required]"
                                :value="driver.license.date ? +driver.license.date.split('-')[0] : null"
                                @change="driver.license.date = $event + '-12-31';"
                                label="Год выдачи первого ВУ"
                            />
                            <osago-date
                                v-if="!driver.license.rememberYearOnly"
                                v-model="driver.license.date"
                                label="Дата выдачи первого ВУ"
                                :isFirstLicense="true"
                                :min="driver.dateFirstLicense"
                                :max="dateToday"
                                :restrictJan1="true"
                                @blur="driver.dateFirstLicense = getDateFirstLicense(driver)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                        <v-flex xs1 pt-0 style="align-self: flex-end">
                            <p class="pt-3 pb-2">
                                <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                                     data-tippy-animateFill="false"
                                     data-tippy-animation="scale"
                                     data-tippy-content="Дата выдачи первого ВУ указана на обратной стороне ВУ."
                                />
                            </p>
                        </v-flex>
                        <v-flex xs12 sm6 md2 py-0 style="align-self: flex-end">
                            <osago-gender
                                v-model="driver.gender"
                                label="Пол"
                                :noField.sync="driver.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 py-0 style="align-self: flex-end">
                            <!-- TODO: поменять потом на autocomplete -->
                            <v-autocomplete
                                v-model="driver.citizenship"
                                label="Гражданство"
                                :items="countriesArray"
                                item-value="value"
                                item-text="text"
                                :rules="[rules.required]"
                                :menu-props="{ minWidth:340, maxWidth:340 }"
                                @change="setPassportType(driver); setCountry(driver)"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout wrap pt-1 v-if="driver.isOwner || driver.isInsurer">
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <h4 style="display: inline">Паспорт</h4>
                            <v-text-field
                                v-model="driver.passport.series"
                                :rules="[rules.base, rules.passportSeriesLength]"
                                @blur="setPassportIssuedBy(driver)"
                                label="Серия"
                                class="pt-1"
                                @keyup.native="driver.passport.series = removeSymbols(driver.passport.series)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="driver.passport.number"
                                :rules="[rules.required, rules.base, rules.passportNumberLength]"
                                @blur="setPassportIssuedBy(driver)"
                                label="Номер"
                                required
                                class="pt-1"
                                @keyup.native="driver.passport.number = removeSymbols(driver.passport.number)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg4 py-0 style="align-self: flex-end">
                            <osago-date
                                inputClass="pt-0"
                                label="Дата выдачи"
                                v-model="driver.passport.date"
                                :passportAgeCheck="driver.dateDriverPassport"
                                :min="driver.dateDriverPassport"
                                :max="dateToday"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout wrap pt-1 v-if="driver.isOwner || driver.isInsurer">
                        <v-flex xs12 md12 lg4 py-0 style="align-self: flex-end">
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />
                            <v-combobox
                                v-model="driver.country"
                                label="Страна"
                                :rules="[rules.required]"
                                :items="countriesArray"
                                disabled
                                item-value="value"
                                item-text="text"
                                @change="clearAddressByCountry(driver)"
                            />
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-if="driver.country && driver.country.value !== '643'">
                            <v-layout row wrap>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="driver.address.region"
                                        label="Регион"
                                        @change="addAddressSearchAndFull(driver)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="driver.address.region = removeSymbols(driver.address.region)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="driver.address.area"
                                        label="Область"
                                        @change="addAddressSearchAndFull(driver)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="driver.address.area = removeSymbols(driver.address.area)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="driver.address.city"
                                        label="Населенный пункт"
                                        :rules="[rules.required, rules.addressString, rules.base]"
                                        @change="addAddressSearchAndFull(driver)"
                                        @keyup.native="driver.address.city = removeSymbols(driver.address.city)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="driver.address.street"
                                        label="Улица"
                                        @change="addAddressSearchAndFull(driver)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="driver.address.street = removeSymbols(driver.address.street)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="driver.address.house"
                                        label="Дом"
                                        @change="addAddressSearchAndFull(driver)"
                                        :rules="[rules.addressString]"
                                        @keyup.native="driver.address.house = removeSymbols(driver.address.house)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="driver.address.flat"
                                        label="Квартира"
                                        @change="addAddressSearchAndFull(driver)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="driver.address.flat = removeSymbols(driver.address.flat)"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-else>
                            <osago-address-dadata
                                :model="driver.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex
                            v-if="drivers.length < 6 && driver.n === drivers.length"
                            shrink pt-0
                            class="driverControls"
                        >
                            <a @click="addDriver(driver)">
                                <img src="/svg/plus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                Добавить водителя
                            </a>
                        </v-flex>
                        <v-flex grow pt-0
                                v-if="drivers.length > 1"
                                class="driverControls"
                        >
                            <a @click="removeDriver(driver)">
                                <img src="/svg/minus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                Убрать водителя
                            </a>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container v-if="!driverIsOwner && !unlimitedDrivers" class="container py-0">
                    <v-layout>
                        <v-flex pb-4 pt-5>
                            <h2 v-if="!driverIsInsurer">
                                Собственник и страхователь
                            </h2>
                            <h2 v-if="driverIsInsurer">
                                Собственник
                            </h2>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="owner.fio.surname"
                                label="Фамилия"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="owner.fio.name"
                                label="Имя"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="owner.fio.noPatronymic"
                                label="Без отчества"
                            />
                            <osago-name
                                v-model="owner.fio.patronymic"
                                label="Отчество"
                                :isDisabled="owner.fio.noPatronymic"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="owner.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="owner.dateDriverPassport = getDateDriverPassport(owner);
                                    owner.dateFirstLicense = getDateFirstLicense(owner)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg5 py-0 style="align-self: flex-end">
                            <h4 style="display: inline">Паспорт</h4>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="owner.passport.series"
                                :rules="[rules.base, rules.passportSeriesLength]"
                                @blur="setPassportIssuedBy(owner)"
                                label="Серия"
                                class="pt-1"
                                @keyup.native="owner.passport.series = removeSymbols(owner.passport.series)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="owner.passport.number"
                                :rules="[rules.required, rules.base, rules.passportNumberLength]"
                                @blur="setPassportIssuedBy(owner)"
                                label="Номер"
                                required
                                class="pt-1"
                                @keyup.native="owner.passport.number = removeSymbols(owner.passport.number)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="owner.passport.date"
                                :passportAgeCheck="owner.dateDriverPassport"
                                :min="owner.dateDriverPassport"
                                :max="dateToday"
                                :isHideMobile="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 py-0 style="align-self: flex-end">
                            <osago-gender
                                v-model="owner.gender"
                                label="Пол"
                                :noField.sync="owner.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 py-0 style="align-self: flex-end">
                            <!-- TODO: поменять потом на autocomplete -->
                            <v-autocomplete
                                v-model="owner.citizenship"
                                label="Гражданство"
                                :items="countriesArray"
                                item-value="value"
                                item-text="text"
                                :rules="[rules.required]"
                                :menu-props="{ minWidth:340, maxWidth:340 }"
                                @change="setPassportType(owner); setCountry(owner)"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 md12 lg4 py-0 style="align-self: flex-end">
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />
                            <v-combobox
                                v-model="owner.country"
                                label="Страна"
                                :rules="[rules.required]"
                                :items="countriesArray"
                                disabled
                                item-value="value"
                                item-text="text"
                                @change="clearAddressByCountry(owner)"
                            />
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-if="owner.country && owner.country.value !== '643'">
                            <v-layout row wrap>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.region"
                                        label="Регион"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.region = removeSymbols(owner.address.region)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.area"
                                        label="Область"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.area = removeSymbols(owner.address.area)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.city"
                                        label="Населенный пункт"
                                        :rules="[rules.required, rules.addressString, rules.base]"
                                        @change="addAddressSearchAndFull(owner)"
                                        @keyup.native="owner.address.city = removeSymbols(owner.address.city)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.street"
                                        label="Улица"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.street = removeSymbols(owner.address.street)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.house"
                                        label="Дом"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.house = removeSymbols(owner.address.house)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.flat"
                                        label="Квартира"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.flat = removeSymbols(owner.address.flat)"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-else>
                            <osago-address-dadata
                                :model="owner.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    style="max-width: 1240px" py-0
                    v-if="driverIsOwner && !driverIsInsurer && !unlimitedDrivers"
                >
                    <v-layout>
                        <v-flex pb-4 pt-5>
                            <h2>Страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="insurer.fio.surname"
                                label="Фамилия"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="insurer.fio.name"
                                label="Имя"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="insurer.fio.noPatronymic"
                                label="Без отчества"
                            />
                            <osago-name
                                v-model="insurer.fio.patronymic"
                                label="Отчество"
                                :isDisabled="insurer.fio.noPatronymic"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="insurer.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="insurer.dateDriverPassport = getDateDriverPassport(insurer);
                                    insurer.dateFirstLicense = getDateFirstLicense(insurer)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg5 py-0 style="align-self: flex-end">
                            <h4 style="display: inline">Паспорт</h4>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="insurer.passport.series"
                                :rules="[rules.base, rules.passportSeriesLength]"
                                @blur="setPassportIssuedBy(insurer)"
                                label="Серия"
                                class="pt-1"
                                @keyup.native="insurer.passport.series = removeSymbols(insurer.passport.series)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="insurer.passport.number"
                                :rules="[rules.required, rules.base, rules.passportNumberLength]"
                                @blur="setPassportIssuedBy(insurer)"
                                label="Номер"
                                required
                                class="pt-1"
                                @keyup.native="insurer.passport.number = removeSymbols(insurer.passport.number)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="insurer.passport.date"
                                :passportAgeCheck="insurer.dateDriverPassport"
                                :max="dateToday"
                                :min="insurer.dateDriverPassport"
                                :isHideMobile="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 py-0 style="align-self: flex-end">
                            <osago-gender
                                v-model="insurer.gender"
                                label="Пол"
                                :noField.sync="insurer.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 py-0 style="align-self: flex-end">
                            <!-- TODO: поменять потом на autocomplete -->
                            <v-autocomplete
                                v-model="insurer.citizenship"
                                label="Гражданство"
                                :items="countriesArray"
                                item-value="value"
                                item-text="text"
                                :rules="[rules.required]"
                                :menu-props="{ minWidth:340, maxWidth:340 }"
                                @change="setPassportType(insurer); setCountry(insurer)"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 md12 lg4 py-0 style="align-self: flex-end">
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />
                            <v-combobox
                                v-model="insurer.country"
                                label="Страна"
                                :rules="[rules.required]"
                                :items="countriesArray"
                                disabled
                                item-value="value"
                                item-text="text"
                                @change="clearAddressByCountry(insurer)"
                            />
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-if="insurer.country && insurer.country.value !== '643'">
                            <v-layout row wrap>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="insurer.address.region"
                                        label="Регион"
                                        @change="addAddressSearchAndFull(insurer)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="insurer.address.region = removeSymbols(insurer.address.region)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="insurer.address.area"
                                        label="Область"
                                        @change="addAddressSearchAndFull(insurer)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="insurer.address.area = removeSymbols(insurer.address.area)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="insurer.address.city"
                                        label="Населенный пункт"
                                        :rules="[rules.required, rules.addressString, rules.base]"
                                        @change="addAddressSearchAndFull(insurer)"
                                        @keyup.native="insurer.address.city = removeSymbols(insurer.address.city)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="insurer.address.street"
                                        label="Улица"
                                        @change="addAddressSearchAndFull(insurer)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="insurer.address.street = removeSymbols(insurer.address.street)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="insurer.address.house"
                                        label="Дом"
                                        @change="addAddressSearchAndFull(insurer)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="insurer.address.house = removeSymbols(insurer.address.house)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="insurer.address.flat"
                                        label="Квартира"
                                        @change="addAddressSearchAndFull(insurer)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="insurer.address.flat = removeSymbols(insurer.address.flat)"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-else>
                            <osago-address-dadata
                                :model="insurer.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    v-if="unlimitedDrivers"
                    style="max-width: 1240px" py-0
                >
                    <v-layout>
                        <v-flex pb-4 pt-5>
                            <h2>Собственник и страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="owner.fio.surname"
                                label="Фамилия"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="owner.fio.name"
                                label="Имя"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="owner.fio.noPatronymic"
                                label="Без отчества"
                            />
                            <osago-name
                                v-model="owner.fio.patronymic"
                                label="Отчество"
                                :isDisabled="owner.fio.noPatronymic"
                                :allowLatinAndRussian="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="owner.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="owner.dateDriverPassport = getDateDriverPassport(owner);
                                    owner.dateFirstLicense = getDateFirstLicense(owner)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout wrap pt-1>
                        <v-flex xs12 sm6 md3 lg5 py-0 style="align-self: flex-end">
                            <h4 style="display: inline">Паспорт</h4>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="owner.passport.series"
                                :rules="[rules.base, rules.passportSeriesLength]"
                                @blur="setPassportIssuedBy(owner)"
                                label="Серия"
                                class="pt-1"
                                @keyup.native="owner.passport.series = removeSymbols(owner.passport.series)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <v-text-field
                                v-model="owner.passport.number"
                                :rules="[rules.required, rules.base, rules.passportNumberLength]"
                                @blur="setPassportIssuedBy(owner)"
                                label="Номер"
                                required
                                class="pt-1"
                                @keyup.native="owner.passport.number = removeSymbols(owner.passport.number)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="owner.passport.date"
                                :passportAgeCheck="owner.dateDriverPassport"
                                :min="owner.dateDriverPassport"
                                :max="dateToday"
                                :isHideMobile="true"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 py-0 style="align-self: flex-end">
                            <osago-gender
                                v-model="owner.gender"
                                label="Пол"
                                :noField.sync="owner.gender"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 py-0 style="align-self: flex-end">
                            <!-- TODO: поменять потом на autocomplete -->
                            <v-autocomplete
                                v-model="owner.citizenship"
                                label="Гражданство"
                                :items="countriesArray"
                                item-value="value"
                                item-text="text"
                                :rules="[rules.required]"
                                :menu-props="{ minWidth:340, maxWidth:340 }"
                                @change="setPassportType(owner); setCountry(owner)"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 md12 lg4 py-0 style="align-self: flex-end">
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />
                            <v-combobox
                                v-model="owner.country"
                                label="Страна"
                                :rules="[rules.required]"
                                :items="countriesArray"
                                disabled
                                item-value="value"
                                item-text="text"
                                @change="clearAddressByCountry(owner)"
                            />
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-if="owner.country && owner.country.value !== '643'">
                            <v-layout row wrap>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.region"
                                        label="Регион"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.region = removeSymbols(owner.address.region)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.area"
                                        label="Область"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.area = removeSymbols(owner.address.area)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.city"
                                        label="Населенный пункт"
                                        :rules="[rules.required, rules.addressString, rules.base]"
                                        @change="addAddressSearchAndFull(owner)"
                                        @keyup.native="owner.address.city = removeSymbols(owner.address.city)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.street"
                                        label="Улица"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.street = removeSymbols(owner.address.street)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.house"
                                        label="Дом"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.house = removeSymbols(owner.address.house)"
                                    />
                                </v-flex>
                                <v-flex lg4>
                                    <v-text-field
                                        class="country-field-padding"
                                        v-model="owner.address.flat"
                                        label="Квартира"
                                        @change="addAddressSearchAndFull(owner)"
                                        :rules="[rules.addressString, rules.base]"
                                        @keyup.native="owner.address.flat = removeSymbols(owner.address.flat)"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0 style="align-self: flex-end" v-else>
                            <osago-address-dadata
                                :model="owner.address"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                    style="max-width: 1240px"
                    pt-0
                >
                    <transit-transport
                        v-model="transport"
                        :dateToday="dateToday"
                        :transition="transition"
                        @update:transition="val => transition = val"
                    />
                </v-container>

                <v-container>
                    <v-layout>
                        <v-flex xs12 pt-3 pb-3>
                            <h2>Условия страхования</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 sm6 md3 pt-0>
                            <v-select
                                v-model="term"
                                :rules="[rules.required]"
                                label="Срок"
                                :items="termArray"
                                item-value='val'
                                item-text='name'
                                class="pt-0"
                                :menu-props="{ bottom: true, offsetY: true }"
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pt-0>
                            <osago-date
                                inputClass="pt-0"
                                label="Дата начала"
                                v-model="dateStart"
                                :yearStarting="false"
                                :min="dateToday"
                                :max="dateStartMax"
                                :isHideMobile="true"
                            />
                        </v-flex>

                        <v-flex xs12 sm6 md4 pt-0>
                            <v-select
                                v-model="useType"
                                label="Цель использования"
                                :rules="[rules.required]"
                                :items="useTypes"
                                item-value="id"
                                item-text="value"
                                class="pt-0"
                                no-data-text="Не удалось найти цели использования"
                                :menu-props="{ bottom: true, offsetY: true }"
                                content-class="truncate-text"
                            />
                        </v-flex>

<!--                        <v-flex xs12 sm6 md4 pt-0>
                            <v-select
                                v-model="paymentSystem"
                                label="Платежная система"
                                :rules="[rules.required]"
                                :items="[
                                    { name: 'Российский платежный сервис', val: 'russian' },
                                    { name: 'Международная платежная система', val: 'international' },
                                ]"
                                item-value='val'
                                item-text='name'
                                class="pt-0"
                            />
                        </v-flex>-->
                    </v-layout>
                </v-container>

                <v-container class="contacts">
                    <v-layout>
                        <v-flex xs12 pt-3 pb-3>
                            <h2>Контакты для получения полиса</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 pt-0>
                            <vue-phone-number-input
                                :default-country-code="user.phoneData.countryCode"
                                :translations="{
                                    countrySelectorLabel: 'Код страны',
                                    countrySelectorError: 'Выберите страну',
                                    phoneNumberLabel: 'Номер телефона',
                                    example: 'Пример :'
                                }"
                                :only-countries="['RU', 'AZ', 'AM', 'BY', 'GE', 'KZ', 'KG', 'CN', 'MN', 'TJ', 'UZ', 'UA']"
                                v-model="user.tempNumberPhone"
                                error-color="#ff5252"
                                valid-color="#00ba57"
                                required
                                @update="updatePhone"
                            />
                            <div class="valid-phone-number" v-if="!isValidPhoneNumber">
                                <p>Неверный формат</p>
                            </div>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0 class="email-field-wrapper">
                            <v-text-field
                                @keydown.space.prevent
                                v-model="user.email"
                                :rules="[emailRules]"
                                label="E-mail (на него придет полис)"
                                validate-on-blur
                                required
                                counter="35"
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0>
                            <span>
                                <span v-html="attention"></span>
                            </span>
                        </v-flex>
                    </v-layout>

                    <v-layout pt-4 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn
                                class="submit-button block to-counting"
                                @click="validate"
                                :loading="isSubmitButtonLoading"
                                v-if="!orderStatus"
                            >
                                {{ 'Рассчитать окончательную стоимость' }}
                            </v-btn>
                            <v-btn
                                class="submit-button block to-counting"
                                :disabled="true"
                                v-else
                            >
                                {{ 'Полис оформлен' }}
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <div class="policy-wrapper">
                                Отправляя анкету, соглашаюсь
                                <br>с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">политикой
                                обработки персональных данных</a>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>

        <transit-list
            ref="transitList"
            :companiesList="companiesList"
            :isFormChanged="isFormChanged"
            :orderStatus="orderStatus"
            :validateAndBuy="validateAndBuy"
            :isErrorCalculate="isErrorCalculate"
            :isSubmitButtonLoading="isSubmitButtonLoading"
            @validate="validate"
        />
    </v-app>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import helperMixin from '../../mixins/helper';

export default {
    props: ['authUser'],

    mixins: [helperMixin],

    async created() {
        // Временная логика
        this.addDriver();
        this.drivers[0].isOwner = true;
        this.drivers[0].isInsurer = true;
        const currentPath = window.location.pathname;
        const uuidFromPath = currentPath.split('/')[2];

        try {
            await Promise.all([
                this.fetchCountries(),
                this.fetchCompanyAliases(),
            ]);
        } catch (error) {
            console.error('Error in fetch:', error);
        } finally {
            this.isFetchesDone = true;
        }

        if (uuidFromPath) {
            this.uuid = uuidFromPath;
            this.getFrontendData();
        } else {
            this.createNewTransit();
        }

        this.autoSaveOn(5000);
    },

    data: () => ({
        uuid: null,
        valid: true,
        term: 90,
        yearBefore: moment().subtract(1, 'years').format('DD.MM.YYYY'),
        dateToday: moment().format('YYYY-MM-DD'),
        dateStart: '',
        dateStartMax: moment().add(60, 'days').format('YYYY-MM-DD'),
        dateDriversMinimal: moment().subtract(18, 'years').format('YYYY-MM-DD'),
        unlimitedDrivers: false,
        drivers: [],
        owner: {
            fio: {
                surname: null,
                name: null,
                patronymic: null,
                noPatronymic: false,
                old: false,
                oldSurname: null
            },
            resident: false, // TODO
            gender: null,
            birthday: null,
            passport: {
                date: null,
                issuedBy: 'МВД РФ',
                series: '',
                number: '',
                type: null, // todo, 7 - Иностранный паспорт, 12 - Паспорт гражданина РФ, 13 - Загранпаспорт,
                isPrimary: true // todo
            },
            address: {
                search: null,
            },
            passportDate: null,
            citizenship: null, // todo
            license: {
                date: null,
                series: '',
                number: '',
                type: null,
            },
        },
        insurer: {
            fio: {
                surname: null,
                name: null,
                patronymic: null,
                noPatronymic: false,
                old: false,
                oldSurname: null
            },
            resident: false, // TODO
            gender: null,
            birthday: null,
            passport: {
                date: null,
                issuedBy: 'МВД РФ',
                series: '',
                number: '',
                type: null, // todo
                isPrimary: true // todo
            },
            address: {
                search: null,
            },
            passportDate: null,
            citizenship: null, // todo
            license: {
                date: null,
                series: '',
                number: '',
                type: null,
            },
        },
        transport: {
            category: null, //'B',
            mark: null,
            model: null,
            writtenMark: null,
            writtenModel: null,
            idType: 'vin',
            vin: null,
            bodyNumber: null,
            chassisNumber: null,
            power: null,
            licensePlate: null,
            noLicensePlate: false,
            yearIssue: null,
            carCode: null,
            loadingLicensePlateInfo: null,
            powerAvtocod: null,
            carDoc: {
                type: '37', // todo
                series: '',
                number: '',
                date: null,
            },
            toDoc: {
                type: '37', // todo
                series: '',
                number: '',
                endDate: null
            },
            docType: 'sts',
        },
        noEquilSeriesNumber: true,
        useType: null,
        useTypes: [
            { id: 1, value: 'Личная' },
            { id: 2, value: 'Учебная езда' },
            { id: 3, value: 'Такси' },
            { id: 4, value: 'Перевозка опасных и легко воспламеняющихся грузов' },
            { id: 5, value: 'Прокат/краткосрочная аренда' },
            { id: 6, value: 'Регулярные пассажирские перевозки/перевозки пассажиров по заказам' },
            { id: 7, value: 'Дорожные и специальные транспортные средства' },
            { id: 8, value: 'Экстренные и коммунальные службы' },
            { id: 9, value: 'Прочее' },
        ],
        paymentSystem: 'russian',
        user: {
            tempNumberPhone: '',
            phone: '',
            email: null,
            phoneCode: null,
            useTempNumber: false,
            tempPhone: null,
            phoneData: {
                countryCode: "RU",
            },
        },
        preparedFormData: null,
        lastSavedFormData: null,
        rules: {
            required: v => !!v || 'Обязательное поле',
            useTarget: v => v || 'Необходимо подтвердить цель использования авто',
            approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных',
            license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
            passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
            policyNumber: v => {
                if (v === '') return true;
                if (typeof v !== 'string') return 'Неверный формат';
                return /^[А-ЯA-Z]{3} \d{10}$/.test(v) || 'Неверный формат';
            },
            addressString: v => {
                if (!v) return true;
                const regex = /^[A-Za-zа-яА-ЯёЁAaCcIHLN№VX0-9\-‒–—/\\|_() ,.'+`<>!"«»„“]*$/;
                return (v.length <= 1000 && regex.test(v)) || 'Неверный формат адреса';
            },
            base: v => /^[\dA-Za-zА-Яа-яЁё\- /.]*$/.test(v) || 'Неверный формат',
            passportSeriesLength: v => {
                if (!v) return true;
                return v.length <= 4 || 'Недопустимое количество символов';
            },
            passportNumberLength: v => {
                if (!v) return true;
                return (v.length >= 6 && v.length <= 18) || 'Недопустимое количество символов';
            },
            licenseSeriesLength: v => {
                if (!v) return true;
                return (v.length >= 2 && v.length <= 4) || 'Недопустимое количество символов';
            },
            licenseNumberLength: v => {
                if (!v) return true;
                return (v.length >= 4 && v.length <= 14) || 'Недопустимое количество символов';
            },
        },
        emailRules: [
            v => !!v || 'Обязательное поле',
            v => !(/[А-ЯЁа-яё\s]/i.test(v)) || 'E-mail не должен содержать кириллицу и пробелы',
            v => !(/[_.-]{2}/.test(v)) || 'Email не должен содержать идущие друг за другом знак подчеркивания, точку и минус',
            v => /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,24}\b/.test(v) || 'Неверный формат',
            v => v.length <= 35 || 'E-mail не должен превышать 35 символов',
        ],
        attention: "<b>ВАЖНО!</b> Проверьте правильность<br>e-mail, на него придет электронный полис ОСАГО",
        companiesList: [],
        countriesArray: [],
        autoSaveInterval: null,
        isSubmitButtonLoading: false,
        orderStatus: null,
        isDataLoaded: false,
        isFetchesDone: false,
        isFormChanged: false,
        isErrorCalculate: null,
        isValidPhoneNumber: true,
        transition: false,
        companyAliases: [],
    }),

    methods: {
        unlimitedDriversChange(val) {
            if (val) {
                let that = this;
                this.drivers = this.drivers.map(driver => {
                    if (driver.isOwner) {
                        that.owner = driver;
                    }
                    return driver;
                });
            } else {
                if (this.drivers === 'unlimited') {
                    let driver = _.cloneDeep(this.owner);
                    driver.license = {
                        date: null,
                        old: false,
                        rememberYearOnly: false,
                        series: '',
                        number: '',
                        oldSeries: '',
                        oldNumber: '',
                    };
                    driver.n = 1;
                    driver.isOwner = driver.isInsurer = true;
                    this.drivers = [driver];
                }
            }
        },

        addDriver() {
            this.drivers.push({
                n: this.drivers.length + 1,
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false,
                    old: false,
                    oldSurname: null,
                },
                license: {
                    date: null,
                    series: '',
                    number: '',
                    type: null,
                },
                passport: {
                    date: null,
                    series: '',
                    number: '',
                    type: null,
                    isPrimary: true, // todo
                    issuedBy: 'МВД РФ',
                },
                address: {
                    search: null,
                },
                birthday: null,
                gender: null,
                citizenship: null,
                resident: false,
            });
        },

        addPopulateDriverFromPreparedForm(driverData) {
            this.drivers.push({
                n: this.drivers.length + 1,
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false,
                    old: false,
                    oldSurname: null,
                    ...driverData.fio, // Перенос данных из формы
                },
                license: {
                    date: null,
                    series: '',
                    number: '',
                    type: null,
                    ...driverData.license, // Перенос данных из формы
                },
                passport: {
                    date: null,
                    series: '',
                    number: '',
                    type: null,
                    isPrimary: true, // todo
                    issuedBy: 'МВД РФ',
                    ...driverData.passport, // Перенос данных из формы
                },
                address: {
                    search: null,
                    ...driverData.address, // Перенос данных из формы
                },
                birthday: null,
                gender: null,
                citizenship: null,
                resident: false,
                ...driverData, // Остальные свойства
            });
        },


        removeDriver(driver) {
            this.$delete(this.drivers, driver.n - 1)

            this.drivers = this.drivers.map(function (drv, index) {
                drv.n = index + 1;
                return drv;
            });
        },

        driverIsOwnerChange(val) {
            this.drivers = this.drivers.map(driver => {
                if (driver.n !== val.n) {
                    driver.isOwner = false;
                }
                return driver;
            });

            if (!val.isInsurer) {
                this.clearPassportAndAddress(val);
            }

            this.clearPerson(this.owner);

            if (val.isOwner && val.isInsurer) {
                val.country = this.countriesArray.find((country) => country.value == val.citizenship);
            }
        },

        driverIsInsurerChange(val) {
            this.drivers = this.drivers.map(driver => {
                if (driver.n !== val.n) {
                    driver.isInsurer = false;
                }
                return driver;
            });

            if (!val.isOwner) {
                this.clearPassportAndAddress(val);
            }

            this.clearPerson(this.insurer);

            if (val.isOwner && val.isInsurer) {
                val.country = this.countriesArray.find((country) => country.value == val.citizenship);
            }
        },

        clearFioAndBirthday(person) {
            person.fio = {
                surname: null,
                name: null,
                patronymic: null,
                noPatronymic: false,
                old: false,
                oldSurname: null
            };
            person.birthday = null;
        },

        clearPassportAndAddress(person) {
            person.passport = {
                date: null,
                series: '',
                number: '',
                type: null,
                isPrimary: true,
                issuedBy: 'МВД РФ',
            };
            person.address = {
                search: null,
            };

            this.setPassportType(person);
        },

        clearPerson(person) {
            this.clearFioAndBirthday(person);
            this.clearPassportAndAddress(person);
            this.setPassportType(person);
        },

        oldSurnameToggle(driver) {
            driver.fio.oldSurname = '';
            if (driver.fio.old && !driver.license.old) {
                driver.license.old = true;
                driver.license.oldSeries = '';
                driver.license.oldNumber = '';
            }
            this.drivers = this.drivers.map(item => item.n === driver.n ? driver : item);
        },

        setGender(person) {
            if (person.fio.patronymic) {
                person.gender = person.fio.patronymic.endsWith('а') ? 'Женский' : 'Мужской';
            }
        },

        setDriverBirthday(driver) {
            if (driver.birthday) {
                const [year, month, day] = driver.birthday.split('-');
                const dateFirstLicense = `${parseInt(year) + 18}-${month}-${day}`;
                const dateDriverPassport = `${parseInt(year) + 14}-${month}-${day}`;
                if (driver.license && driver.license.date) {
                    if (driver.license.date > this.dateToday) {
                        driver.license.date = this.dateToday;
                    } else if (driver.license.date < dateFirstLicense) {
                        driver.license.date = dateFirstLicense;
                    }
                }
                return {dateFirstLicense: dateFirstLicense, dateDriverPassport: dateDriverPassport};
            }
        },

        setPassportIssuedBy(person) {
            if (person.passport.series && person.passport.number) {
                person.passport.issuedBy = 'МВД РФ';
            }
        },

        getDateDriverPassport(driver) {
            let dates = this.setDriverBirthday(driver);
            return dates ? dates.dateDriverPassport : this.dateDriversMinimal;
        },

        getDateFirstLicense(driver) {
            let dates = this.setDriverBirthday(driver);
            return dates ? dates.dateFirstLicense : this.dateDriversMinimal;
        },

        getFirstLicenseYears(minDate, maxDate) {
            const minYear = minDate ? +minDate.split('-')[0] : 1920;
            const maxYear = maxDate ? +maxDate.split('-')[0] : 2099;
            let years = [];
            for (let i = maxYear; i >= minYear; i--) {
                years[years.length] = i;
            }
            return years;
        },

        oldLicenseToggle(driver) {
            driver.license.oldSeries = '';
            driver.license.oldNumber = '';
            if (!driver.license.old && driver.fio.old) {
                driver.fio.old = false;
                driver.fio.oldSurname = '';
            }
            this.drivers = this.drivers.map(item => item.n === driver.n ? driver : item);
        },

        inputOldLicenseNumber(event, driver) {
            if (event === driver.license.seriesNumber) {
                this.noEquilSeriesNumber = 'Не может совпадать с номером нового ВУ'
            } else {
                this.noEquilSeriesNumber = true
            }
        },

        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },

        validate() {
            if (this.$refs.form.validate() && this.isValidPhoneNumber) {
                this.submit();
            } else {
                this.$nextTick(() => {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                })
            }
        },

        validateAndBuy(company) {
            if (this.$refs.form.validate()) {
                this.$refs.transitList.buy(company);
            } else {
                this.$nextTick(() => {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },

        prepareFormData() {
            let owner = _.cloneDeep(this.owner);
            let insurer = _.cloneDeep(this.insurer);

            if (!this.unlimitedDrivers) {
                this.drivers.forEach(function (driver) {
                    if (driver.isOwner) owner = _.cloneDeep(driver);
                    if (driver.isInsurer) insurer = _.cloneDeep(driver);
                });
            }

            if ((!this.driverIsInsurer && !this.driverIsOwner) || this.unlimitedDrivers) {
                insurer = _.cloneDeep(this.owner);
            }

            this.preparedFormData = {
                term: _.cloneDeep(this.term),
                dateStart: _.cloneDeep(this.dateStart),
                useType: this.useType,
                drivers: this.unlimitedDrivers ? 'unlimited' : _.cloneDeep(this.drivers),
                owner: owner,
                insurer: insurer,
                transport: _.cloneDeep(this.transport),
                user: _.cloneDeep(this.user),
                paymentSystem: this.paymentSystem,
                transition: this.transition,
            }
        },

        // TODO на подумать
        // перед началом расчета проведем обновление form_data - и на монолите, и на микросервисе
        // это позволит проверить расчет на микросервисе и тянуть туда form_data (мы получим все данные из БД на микросервисе)
        /*submit() {
            this.isSubmitButtonLoading = true;
            this.prepareFormData();
            this.isErrorCalculate = false;
            this.$nextTick(() => {
                console.log(this.preparedFormData)

                this.update(this.preparedFormData)
                    .then(() => {
                        setTimeout(() => {
                            axios.get(`/api/transit/calculate/soglasie/${this.uuid}`)
                                .then(response => {
                                    if (response && response.data && response.data.company && response.data.data) {
                                        const companyData = response.data.company;
                                        const paymentData = response.data.data;

                                        const company = {
                                            id: companyData.id, // ID страховой
                                            alias: companyData.alias, // Алиас страховой
                                            image: companyData.image, // Изображение страховой
                                            payment: {
                                                premium: paymentData.premium, // Цена полиса
                                                commission: paymentData.agent_fee_percent, // Вознаграждение в %
                                                commission_rub: paymentData.agent_fee_value, // Вознаграждение в рублях
                                                period: paymentData.policy_type, // Тип полиса (срок действия)
                                                base: paymentData.bt, // Базовый тариф
                                                kbm: paymentData.kbms[0],
                                                kc: paymentData.kc,
                                                km: paymentData.km,
                                                ko: paymentData.ko,
                                                kt: paymentData.kt,
                                                kvc: paymentData.kvc,
                                                wait: false,
                                            },
                                        };

                                        this.companiesList.splice(0, this.companiesList.length, company);
                                    } else if (response && response.data && !response.data.company && response.data.data) {
                                        this.companiesList = [];
                                        console.error("Ошибка: ", response.data.data);
                                        this.isErrorCalculate = true;

                                        // Потом переделать, чтоб возвращалось всё с бэка, пока зашитое Согласие
                                        const company = {
                                            id: 4, // id Согласия
                                            alias: 'soglasie',
                                            image: window.location.origin + '/uploads/company_logo/a552eba89d73fe71ece1ac48833d1922.svg',
                                            status: 'error',
                                            error: response.data.data,
                                        };

                                        this.companiesList.splice(0, this.companiesList.length, company);

                                    } else {
                                        this.companiesList = [];
                                        console.error("Ошибка: ", response);
                                        this.isErrorCalculate = true;
                                    }
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.isErrorCalculate = true;
                                })
                                .finally(() => {
                                    this.isSubmitButtonLoading = false;
                                    this.isFormChanged = false;
                                })
                        }, 500);
                    })
                    .catch(error => {
                        console.error(error);
                    })
            })
        },*/

        submit() {
            this.isSubmitButtonLoading = true;
            this.prepareFormData();
            this.isErrorCalculate = false;
            this.isFormChanged = false;

            // Проверка: должен быть хотя бы один водитель, отмеченный как собственник или страхователь
            if (Array.isArray(this.preparedFormData.drivers)) {
                const drivers = this.preparedFormData.drivers;
                const hasOwnerOrInsurer = drivers.some(d => d && (d.isOwner || d.isInsurer));
                if (!hasOwnerOrInsurer) {
                    this.isSubmitButtonLoading = false;
                    if (drivers.length === 1) {
                        PNotify.error('Необходимо указать водителя как собственника или страхователя.');
                    } else {
                        PNotify.error('Необходимо указать одного из водителей как собственника или страхователя');
                    }
                    return;
                }
            }

            this.companiesList = this.companyAliases.map(alias => ({
                id: null,
                alias,
                image: window.location.origin + '/uploads/company_logo/' + alias + '.svg',
                payment: { wait: true },
            }));

            this.$nextTick(() => {
                this.update(this.preparedFormData)
                    .then(() => {
                        setTimeout(() => {
                            this.companyAliases.forEach(alias => {
                                axios.get(`/api/transit/calculate/${alias}/${this.uuid}`)
                                    .then(response => {
                                        // Защищаемся от повторного использования предыдущей ошибки:
                                        // формируем ошибку локально для конкретной компании.
                                        let updated;

                                        if (response && response.data && response.data.company && response.data.data) {
                                            const companyData = response.data.company;
                                            const paymentData = response.data.data;

                                            updated = {
                                                id: companyData.id,
                                                alias: companyData.alias,
                                                image: companyData.image,
                                                error_message: companyData.error_text, // сообщение об ошибке
                                                status: companyData.status,
                                                payment: {
                                                    premium: paymentData.premium,
                                                    commission: paymentData.agent_fee_percent,
                                                    commission_rub: paymentData.agent_fee_value,
                                                    period: paymentData.policy_type,
                                                    base: paymentData.bt,
                                                    kbm: paymentData.kbms[0],
                                                    kc: paymentData.kc,
                                                    km: paymentData.km,
                                                    ko: paymentData.ko,
                                                    kt: paymentData.kt,
                                                    kvc: paymentData.kvc,
                                                    wait: false,
                                                },
                                            };
                                        } else if (response && response.data && !response.data.company) {
                                            const errorMessage = response.data.data || 'Неизвестная ошибка';
                                            updated = {
                                                id: null,
                                                alias,
                                                image: window.location.origin + '/uploads/company_logo/' + alias + '.svg',
                                                status: 'error',
                                                error_message: errorMessage,
                                                payment: { wait: false },
                                            };
                                        } else {
                                            updated = {
                                                id: null,
                                                alias,
                                                image: window.location.origin + '/uploads/company_logo/' + alias + '.svg',
                                                status: 'error',
                                                error_message: 'Неизвестная ошибка',
                                                payment: { wait: false },
                                            };
                                        }

                                        const idx = this.companiesList.findIndex(c => c.alias === alias);
                                        if (idx !== -1) {
                                            this.$set(this.companiesList, idx, updated);
                                        }
                                    })
                                    .catch(error => {
                                        console.error(`Ошибка расчёта для ${alias}: `, error);
                                        const idx = this.companiesList.findIndex(c => c.alias === alias);
                                        if (idx !== -1) {
                                            this.$set(this.companiesList, idx, {
                                                id: null,
                                                alias,
                                                image: window.location.origin + '/uploads/company_logo/' + alias + '.svg',
                                                status: 'error',
                                                error_message: 'Ошибка запроса',
                                                payment: { wait: false }
                                            });
                                        }
                                    })
                                    .finally(() => {
                                        if (this.companiesList.every(c => c.payment && c.payment.wait === false)) {
                                            this.isSubmitButtonLoading = false;
                                        }
                                    });
                            });
                        }, 500);
                    })
                    .catch(error => {
                        console.error(error);
                        this.isSubmitButtonLoading = false;
                    });
            });
        },

        update(formData) {
            return axios.post(`/api/transit/${this.uuid}/update`, {
                form_data: formData,
                uuid: this.uuid
            })
                .then(response => {
                    if (response.data) {
                        console.log(response.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },

        createNewTransit() {
            const url = 'api/transit/new';
            axios.get(url)
                .then(response => {
                    if (response && response.data && response.data.data && response.data.data.data.uuid) {
                        this.uuid = response.data.data.data.uuid;
                        const newUrl = `/transit-osago/${this.uuid}`;

                        window.history.pushState(null, '', newUrl);
                        window.location.href = newUrl;
                    } else {
                        console.error('Ошибка при получении uuid', response);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.isDataLoaded = true;
                    }, 1000);
                });
        },


        // todo
        getFrontendData() {
            axios.get(`/api/transit/${this.uuid}`)
                .then(response => {
                    if (response.data) {
                        this.preparedFormData = response.data.params.orderData;
                        this.populateDataFromPreparedForm(); // Автозаполнение

                        this.companiesList = response.data.params.companiesList.map(company => ({
                            id: company.payment.companyId, // id страховой
                            alias: company.payment.companyAlias, // алиас страховой
                            image: company.payment.companyImage, // изображение страховой
                            error_message: company.error_text, // сообщение об ошибке
                            status: company.status, // статус расчета
                            payment: {
                                premium: company.payment.premium, // цена полиса
                                commission: company.payment.commission, // вознаграждение в %
                                commission_rub: company.payment.commission_rub, // вознаграждение в рублях
                                period: company.payment.period, // срок действия
                                base: company.payment.base, // базовый тариф
                                kbm: company.payment.kbm, // kbm
                                kc: company.payment.kc, // кс
                                km: company.payment.km, //
                                ko: company.payment.ko,
                                kt: company.payment.kt,
                                kvc: company.payment.kvc,
                                status: company.payment.offer_status_for_frontend,
                                wait: false,
                            }
                        }));

                        this.orderStatus = response.data.params.orderStatus === 'success';
                    } else {
                        console.error('Ошибка: ', response);
                    }
                })
                .catch(error => {
                    console.log(error);
                    if (this.authUser && (this.authUser.email || this.authUser.phone)) {
                        this.user.email = this.authUser.email ? this.authUser.email : null;

                        if (this.authUser.phone) {
                            const phoneDigits = this.authUser.phone.replace(/\D/g, '');
                            this.user.phone = phoneDigits;
                            this.$nextTick(() => {
                                this.user.tempNumberPhone = '+' + phoneDigits;
                            });
                        }
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        this.isDataLoaded = true;
                        if (this.user && this.user.phoneData) {
                            this.updatePhone(this.user.phoneData);
                        }
                    }, 1000);
                });
        },

        populateDataFromPreparedForm() {
            if (!this.preparedFormData) return;
            console.log(this.preparedFormData)

            const { term, user, owner, drivers, insurer, transport, paymentSystem, useType, transition } = this.preparedFormData;

            if (term) this.term = term;

            if (user) this.user = { ...this.user, ...user };
            if (!user.phone) {
                if (this.authUser.phone) {
                    const phoneDigits = this.authUser.phone.replace(/\D/g, '');
                    this.user.phone = phoneDigits;
                    this.$nextTick(() => {
                        this.user.tempNumberPhone = '+' + phoneDigits;
                    });
                }
            }
            if (!user.email) {
                this.user.email = this.authUser.email ? this.authUser.email : '';
            }

            if (owner) this.owner = { ...this.owner, ...owner };
            if (insurer) this.insurer = { ...this.insurer, ...insurer };
            if (transport) this.transport = { ...this.transport, ...transport };
            if (paymentSystem) this.paymentSystem =  paymentSystem;
            if (useType) this.useType =  useType;
            if (transition) this.transition = transition;

            if (drivers && Array.isArray(drivers)) {
                this.drivers = [];
                drivers.forEach(driver => this.addPopulateDriverFromPreparedForm(driver));
                drivers.forEach(driver => this.setPassportType(driver));
            } else if (drivers === 'unlimited') {
                this.unlimitedDrivers = true;
            }

            if (this.preparedFormData.dateStart) {
                this.dateStart = this.preparedFormData.dateStart;
            }

            if (this.transport.noLicensePlate) {
                this.transition = true;
            }

            if (transport && transport.carDoc && transport.carDoc.type) {
                this.transport.docType = transport.carDoc.type === '37' ? 'sts' : 'pts';
            }
        },

        async fetchCountries() {
            try {
                const response = await axios.get('/transit/get-countries');
                this.countriesArray = Object.values(response.data)
                    .map(country => ({
                        ...country,
                        value: country.value.toString(),
                    }))
                    .sort((a, b) => a.text.localeCompare(b.text, 'ru'));
            } catch (error) {
                console.error('fetchCountries: ', error);
            }

            /*const countriesArray = [
                { value: 643, text: 'РОССИЯ' },
                { value: 398, text: 'КАЗАХСТАН' },
                { value: 840, text: 'СОЕДИНЕННЫЕ ШТАТЫ' },
            ];

            this.countriesArray = countriesArray;*/
        },

        async fetchCompanyAliases() {
            try {
                const response = await axios.get('/api/transit/dictionary/companies');
                let companies = JSON.parse(response.data.data);
                this.companyAliases = companies.map(c => c.company_alias);
            } catch (error) {
                console.error('fetchCompanyAliases: ', error);
            }
        },

        setPassportType(person) {
            if (person.citizenship == '643') {
                person.passport.type = 12;
                person.license.type = 20;
            } else {
                person.passport.type = 7;
                person.license.type = 22;
            }
        },

        setCountry(person) {
            person.country = this.countriesArray.find((country) => country.value == person.citizenship);
        },

        clearAddressByCountry(person) {
            person.address = {};
            person.address.search = null;
        },

        addAddressSearchAndFull(person) {
            const addressParts = [
                person.address.region,
                person.address.area,
                person.address.city,
                person.address.street,
                person.address.house,
                person.address.flat
            ];

            person.address.search = addressParts.filter(Boolean).join(', ');
            person.address.full = person.address.search;
        },

        autoSaveOn(timeout) {
            let that = this;
            this.autoSaveInterval = setInterval(function () {
                that.prepareFormData();

                if (that.lastSavedFormData == null) {
                    that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                    return;
                }

                if (!_.isEqual(that.lastSavedFormData, that.preparedFormData)) {
                    that.update(that.preparedFormData);
                    that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                }
            }, timeout);
        },

        updatePhone(phoneData) {
            if (phoneData && phoneData.formattedNumber) {
                this.user.phone = phoneData.formattedNumber.replace("+", "");
                this.user.phoneData = phoneData;
                this.isValidPhoneNumber = phoneData.isValid;
            }
        },

        removeSymbols: function (val) {
            if (!val) return '';
            const textRegex = /[^0-9A-Za-zА-ЯЁа-яё\- ./]/g;
            val = val
                .toString()
                .replace(/[ ]+/g, ' ')      // несколько пробелов в один
                .replace(/[-]+/g, '-')      // несколько тире в одно
                .replace(/[/.]+/g, m => m[0]) // несколько подряд точек или слэшей в один символ
                .replace(/^[ \-/.]/g, '')   // убрать пробел, тире, точку или слэш в начале строки
                .replace(/ [-/.]/g, match => match.trim()) // убрать пробел перед тире, точкой или слэшем
                .replace(/[-/.] /g, match => match.trim()) // убрать пробел после тире, точки или слэша
                .replace(textRegex, '');
            return val;
        },
    },

    computed: {
        driverIsOwner() {
            return _.findIndex(this.drivers, driver => driver.isOwner) !== -1;
        },

        driverIsInsurer() {
            return _.findIndex(this.drivers, driver => driver.isInsurer) !== -1;
        },

        termArray() {
            if (this.transition) {
                return [
                    { name: '15 дней', val: 15 },
                    { name: '20 дней', val: 20 },
                ]
            } else {
                return [
                    { name: '15 дней', val: 15 },
                    { name: '20 дней', val: 20 },
                    { name: '1 мес', val: 30 },
                    { name: '2 мес', val: 60 },
                    { name: '3 мес', val: 90 },
                    { name: '4 мес', val: 120 },
                    { name: '5 мес', val: 150 },
                    { name: '6 мес', val: 180 },
                    { name: '7 мес', val: 210 },
                    { name: '8 мес', val: 240 },
                    { name: '9 мес', val: 270 },
                    { name: '1 год', val: 360 },
                ];
            }
        },
    },

    watch: {
        unlimitedDrivers: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            }
        },
        drivers: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            },
            deep: true,
        },
        owner: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            },
            deep: true,
        },
        insurer: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            },
            deep: true,
        },
        transport: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            },
            deep: true,
        },
        term: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            }
        },
        dateStart: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            }
        },
        useType: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            }
        },
        transition: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
                this.term = null;
            }
        },
        /*paymentSystem: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            }
        },*/
        user: {
            handler() {
                if (this.isDataLoaded && this.isFetchesDone) {
                    this.isFormChanged = true;
                }
            },
            deep: true,
        },
    },

    updated: function () {
        window.tippy.default('.tip-icon');
    },
}

</script>

<style lang="scss">
.input-tel {
    height: 56px !important;
    min-height: 56px !important;

    &__input {
        height: 56px !important;
        min-height: 56px !important;
        background-color: #e8e8e8 !important;
    }
}

.country-selector {
    height: 56px !important;
    min-height: 56px !important;

    &__input {
        height: 56px !important;
        min-height: 56px !important;
        background-color: #e8e8e8 !important;
    }
}

.contacts {
    .v-text-field {
        padding-top: 0;
        margin-top: 0;
    }
}

.transit {
    @media(max-width: 600px) {
        .v-menu__content {
            box-shadow: none !important;
        }
    }
}

.v-select__selection {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.v-select__selections {
    flex-wrap: nowrap !important;
}
</style>

<style scoped lang="scss">
.container {
    max-width: 1240px !important;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 100px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: normal;
    padding: 0 50px;
    line-height: 1.1;
}

.policy-wrapper {
    text-align: left;
    display: table-cell;
    vertical-align: middle;
    height: 100px;
}

.transit {
    &__header {
        h1 {
            font-family: 'SFPro', 'Arial', 'sans-serif';
            font-size: 65px;
            color: #000000;
            line-height: 1.2;
            font-weight: 700;

            @media(max-width: 960px) {
                font-size: 44px;
                line-height: 1;
            }
        }

        .header-link {
            font-family: 'SFPro', 'Arial', 'sans-serif';
            display: block;
            padding: 24px 0;
            color: #00ba57 !important;
            text-decoration: underline;
        }
    }

    &__drivers {
        &__header {
            h2 {
                font-family: 'SFProBold', 'Arial', 'sans-serif';
                font-size: 28px;
            }
        }
    }

    &__drivers-list {
        &__header {
            h3 {
                font-family: 'SFProBold', 'Arial', 'sans-serif';
                font-size: 20px;
            }
        }
    }

    .valid-phone-number {
        p {
            color: #ff5252;
            font-size: 12px;
            padding-top: 8px;
            line-height: 1;
        }
    }

    .padding-right {
        padding-right: 10px;

        @media(max-width: 600px) {
            padding-right: 0;
        }
    }

    .padding-left {
        padding-left: 10px;

        @media(max-width: 600px) {
            padding-left: 0;
        }
    }

    .country-field-padding {
        padding: 12px 10px 0;

        @media(max-width: 600px) {
            padding: 0;
        }
    }

    .email-field-wrapper {
        z-index: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/transit-osago/TransitOsago.vue